import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { RootState } from "src/redux/reducers";
import { ReactComponent as ThunderIcon } from "src/images/thunder-move.svg";
import { setCreateNewProjectData } from "src/redux/main/mainActions";
import { selectedCreatorsPayload } from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/components/SelectedCreatorsBar/utils";

interface CreateProjectButtonProps {
  handleOpenCreateNewProjectPane: () => void;
}

export default function CreateProjectButton({
  handleOpenCreateNewProjectPane,
}: CreateProjectButtonProps) {
  const {
    creatorSearchReducer: {
      selectedInfluencersOnResultsUrls,
      searchAudienceResult,
    },
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const dispatchCreateNewProjectData = () => {
    dispatch(
      setCreateNewProjectData({
        selectedCreatorsPayload: selectedCreatorsPayload(
          selectedInfluencersOnResultsUrls,
          searchAudienceResult,
        ),
      }),
    );
  };

  return (
    <Button
      variant="blue"
      size="large"
      onClick={() => {
        dispatchCreateNewProjectData();
        handleOpenCreateNewProjectPane();
      }}
      className="create-project-button"
    >
      <ThunderIcon />
      <span>
        <IDHFormattedMessage
          id="ws_create_campaign"
          defaultMessage="Create campaign"
        />
        {selectedInfluencersOnResultsUrls.length > 0 &&
          `: ${selectedInfluencersOnResultsUrls.length}`}
      </span>
    </Button>
  );
}
